import { req } from '../../@api/request';

export default class NewMapService {
  static markerList = async ({
    swLat,
    swLng,
    neLat,
    neLng,
    type,
    itemCode,
    status,
    specialCondition,
    specialItems,
    zoomLevel,
    minPrice,
    maxPrice,
    minSaleDate,
    maxSaleDate,
    minBidCount,
    maxBidCount,
  }: {
    swLat: number;
    swLng: number;
    neLat: number;
    neLng: number;
    type: string;
    itemCode: string;
    status: string;
    specialCondition: string;
    specialItems: string;
    zoomLevel: number;
    minPrice: string;
    maxPrice: string;
    minSaleDate: string;
    maxSaleDate: string;
    minBidCount: string;
    maxBidCount: string;
  }) => {
    const result = await req.get(
      `/map/markers/list2?swLat=${swLat}&swLng=${swLng}&neLat=${neLat}&neLng=${neLng}` +
        `&type=${type}&itemCode=${itemCode}&status=${status}` +
        `&specialCondition=${specialCondition}&specialItems=${specialItems}&zoom=${zoomLevel}` +
        `&minPrice=${minPrice}&maxPrice=${maxPrice}&minSaleDate=${minSaleDate}&maxSaleDate=${maxSaleDate}` +
        `&minBidCount=${minBidCount}&maxBidCount=${maxBidCount}`,
    );
    return result.data;
  };

  static getList = async (
    swLat: number,
    swLng: number,
    neLat: number,
    neLng: number,
    type: string,
    itemCode: string,
    status: string,
    specialCondition: string,
    specialItems: string,
    sort: string,
    offset: number,
    limit: number,
  ) => {
    const result = await req.get(
      `/map/list?swLat=${swLat}&swLng=${swLng}&neLat=${neLat}&neLng=${neLng}&type=${type}&itemCode=${itemCode}&status=${status}&specialCondition=${specialCondition}&specialItems=${specialItems}&sort=${sort}&offset=${offset}&limit=${limit}`,
    );
    return result.data;
  };
}
